import { createContext } from "react";

export interface IOPItem {
    itemId: string;
    itemAuthId: string;
    bic: string;
    clientId: string;
    legalNumber: string;
}

export const OPItemPlaceHolder: IOPItem = {
    itemId: null,
    itemAuthId: null,
    bic: "",
    clientId: "",
    legalNumber: ""
};

export type IOPItemContext = {
    opItem: IOPItem;
    setOPItem: (opItem: IOPItem) => void;
};

const defaultOPItemContext: IOPItemContext = {
    opItem: OPItemPlaceHolder,
    setOPItem: (): void => {}
};

export const OPItemContext = createContext<IOPItemContext>(defaultOPItemContext);

export const getLocalOPItemState = (): IOPItem => {
    return JSON.parse(localStorage.getItem("opItem"));
};

export const setLocalOPItemState = (opItem: IOPItem) => {
    localStorage.setItem("opItem", JSON.stringify(opItem));
};

export const clearLocalOPItemState = () => {
    localStorage.removeItem("opItem");
};

export const initialOPItemState = getLocalOPItemState() || OPItemPlaceHolder;

export const opItemReducer = (state: IOPItem, newState) => {
    if (state.itemId !== newState.itemId) {
        setLocalOPItemState(newState);
    }
    return { ...state, ...newState };
};
